import React from 'react'
import {polyglot} from '../index'
import PanelWithContent from '../components/common/PanelWithContent/PanelWithContent'
import FormRenderer from '../components/common/FormRenderer/FormRenderer'

export function getTranslationForKey (key) {
  if (polyglot) {
    if (!polyglot.has(key)) {
      if (!polyglot.has(`${key}.label`)) {
        return key
      } else {
        return polyglot.t(`${key}.label`)
      }
    } else {
      return polyglot.t(key)
    }
  } else {
    return key
  }
}

function getSavedDataForPanel (key, dataObject) {
  if (key === 'patientIdentification') {
    return getPatientPersonalData(dataObject)
  } else {
    if (dataObject.hasOwnProperty('data')) {
      return dataObject['data'][key]
    }
  }
}

function getPatientPersonalData (patientObject) {
  return patientObject
}

export function getSymbolForString (string) {
  switch (string) {
    case 'negative':
      return <span className='glyphicon glyphicon-remove' />
    case 'positive':
      return <div className={'warning-box'}><span className=''>!</span></div>
    default:
      return <span>{getTranslationForKey(string)}</span>
  }
}

export function getSymbolsForArrayOfString (array) {
  const result = []
  array.map((element, index) => {
    switch (element) {
      case 'negative':
        result.push(<div key={index}><span className='glyphicon glyphicon-remove' /><br /></div>)
        return null
      case 'positive':
        result.push(<div key={index}><span className='glyphicon glyphicon-ok' /><br /></div>)
        return null
      default:
        result.push(<div key={index}><span>{getTranslationForKey(element)}</span><br /></div>)
        return null
    }
  })
  return <div>{result}</div>
}

export function renderPanelWithContent (data, saveData, savedDataObject, expandInputFields) {
  return data.map(element => {
    let savedData = getSavedDataForPanel(element.key, savedDataObject || {})
    return <PanelWithContent
      expandInputFields={expandInputFields}
      extraFieldContent={element.extraFieldContent}
      saveData={saveData}
      key={element.key}
      savedData={savedData}
      dataKey={element.key}
      title={element.title}
      fields={element.fields}
      extraFieldEnabled={element['isExtraFieldEnabled']} />
  })
}

export function renderFormWithContent (data, saveData, dataObject) {
  return data.map(element => {
    let savedData = getSavedDataForPanel(element.key, dataObject || {})
    return <FormRenderer
      extraFieldContent={element.extraFieldContent}
      saveData={saveData}
      key={element.key}
      savedData={savedData}
      dataKey={element.key}
      title={element.title}
      fields={element.fields}
      extraFieldEnabled={element['isExtraFieldEnabled']} />
  })
}

export function getDescriptionForAge (age) {
  if (age <= 24) {
    return polyglot.t('staticFields.numMonths', {smart_count: age})
  } else {
    let years = Math.floor(age / 12)
    return polyglot.t('staticFields.numYears', {smart_count: years})
  }
}



// WEBPACK FOOTER //
// ./src/resources/renderingUtilities.js